// import './src/why-did-you-render'; // uncomment to diagnose re-render issues

// anything that must run first before everything else
import './src/styles';
import 'react-native-reanimated';
import 'react-native-get-random-values';
import { enableFreeze, enableScreens } from 'react-native-screens';

// for some reason web requires this or it bombs on local storage calls. TODO FIX
import Cognito from './src/utils/cognito/storage';

Cognito.getItem('FAKE');
enableScreens(true);
enableFreeze(true);

// normal app start invokes src/app/_layout.tsx
// eslint-disable-next-line import/first
import 'expo-router/entry';
